// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filtersLayoutStyles } from "@awc/App/Widgets/MyLists/MyListsFilterLayout";
import { color, xScreen } from "@awc/XDL/Utilities";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { PaginationStyle } from "@insite/mobius/Pagination";
import { css } from "styled-components";

filtersLayoutStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 22px;
        row-gap: 16px;
        justify-content: space-between;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

filtersLayoutStyles.leftSideContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        column-gap: 22px;
        row-gap: 12px;
        ${xScreen("lte", "md")} {
            flex: 1;
            > div:first-child {
                flex: 1;
            }
        }
        ${xScreen("lte", "sm")} {
            > div {
                &:first-child {
                    flex: 1 100%;
                }
                &:not(:first-child) {
                    width: calc(50% - 11px);
                }
            }
        }
    `,
};

filtersLayoutStyles.pagination = {
    css: css`
        ${xScreen("lte", "sm")} {
            border-top: 1px solid ${color("common.border")};
            padding-top: 12px;
        }
        ${PaginationStyle} {
            ${xScreen("lte", "sm")} {
                justify-content: space-between;
            }
            ${FormInputWrapper} {
                width: 47px;
            }
        }
    `,
};
